import { Component, Input } from '@angular/core';
import { DialogConfig } from 'src/app/modules/shared/components/alert-dialog/dialog-config';
import { TableColumnOption } from 'src/app/modules/shared/components/table-pro/table.config';
import { UserInfo } from 'src/app/modules/shared/models/form/user-info.model';
import { OrganizationType } from 'src/app/modules/shared/models/staff/organization-type.enum';
import { User } from 'src/app/modules/shared/models/staff/user.model';

@Component({
  selector: 'app-dialog-jtys105-sp1',
  templateUrl: './dialog-jtys105-sp1.component.html',
  styleUrls: ['./dialog-jtys105-sp1.component.scss'],
})
export class DialogJtys105Sp1Component {
  @Input() data!: DialogConfig<{
    userList: User[];
    no_4_DepartmentId: string;
    no_13_UserId: string;
    no_14_UserId: string;
    suUserId: string;
  }>;

  no_4_DepartmentId: string = '';

  no_4_UserId: string = '';

  no_12_UserId: string = '';

  no_13_UserId: string = '';

  no_14_UserId: string = '';

  suUserId: string = '';

  // cascaderValueMap: { [key: string]: any[] } = {};

  userTreeNodesMap: { [key: string]: User[] } = {};

  subSu: User[] = [];

  su: User[] = [];

  departments: TableColumnOption[] = [];

  userList: User[] = [];

  constructor() {}

  ngOnInit() {
    this.prepareData();
  }

  private prepareData() {
    console.log(this.data.data);
    // 然后根据单位id来过滤用户列表，获取建设单位的用户列表
    const users = this.data
      .data!.userList.filter(
        (user) => user.organizationType === OrganizationType.DEVELOPMENT,
      )
      .sort((a, b) => +b.postSortOrder! - +a.postSortOrder!);
    this.userList = users;
    const departmentsUserMap: { [key: string]: User[] } = {};
    const departments: TableColumnOption[] = [];
    const subSu: User[] = [];
    const su: User[] = [];
    for (const user of users) {
      if (!departmentsUserMap[user.departmentId!]) {
        departmentsUserMap[user.departmentId!] = [];
        if (!user.departmentName!.includes('领导')) {
          departments.push({
            label: user.departmentName!,
            value: user.departmentId!,
          });
        }
      }
      departmentsUserMap[user.departmentId!.toString()].push(user);
      if (user.postName!.includes('副指挥长')) {
        subSu.push(user);
      } else if (user.postName!.includes('指挥长')) {
        su.push(user);
      }
    }
    this.subSu = subSu;
    this.su = su;
    this.userTreeNodesMap = departmentsUserMap;
    this.departments = departments;
    this.no_4_DepartmentId = this.data.data!.no_4_DepartmentId;
    this.no_13_UserId = this.data.data!.no_13_UserId;
    this.no_14_UserId = this.data.data!.no_14_UserId;
    this.suUserId = this.data.data!.suUserId;
    if (!this.no_4_DepartmentId) {
      this.no_4_DepartmentId = departments[0].value.toString();
    }
    if (this.su.length === 0) {
      this.suUserId = '';
    }
    let contain = false;
    for (const u of this.su) {
      if (`${u.id}` === `${this.suUserId}`) {
        contain = true;
        break;
      }
    }
    if (!contain) {
      this.suUserId = '';
    }
    if (this.subSu.length === 0) {
      this.no_12_UserId = '';
      this.no_13_UserId = '';
      this.no_14_UserId = '';
    }
    contain = false;
    for (const u of this.subSu) {
      if (`${u.id}` === `${this.no_13_UserId}`) {
        contain = true;
        break;
      }
    }
    if (!contain) {
      this.no_13_UserId = '';
    }
    contain = false;
    for (const u of this.subSu) {
      if (`${u.id}` === `${this.no_14_UserId}`) {
        contain = true;
        break;
      }
    }
    if (!contain) {
      this.no_14_UserId = '';
    }
    this.onNo3DepartmentChange();
  }

  onNo3DepartmentChange() {
    if (
      this.userTreeNodesMap[this.no_4_DepartmentId] &&
      this.userTreeNodesMap[this.no_4_DepartmentId].length > 0
    ) {
      this.no_4_UserId =
        this.userTreeNodesMap[this.no_4_DepartmentId][0].id!.toString();
    } else {
      this.no_4_UserId = '';
    }

    const departmentName = this.departments.find(
      (dep) => dep.value.toString() === this.no_4_DepartmentId,
    )!.label;
    if (departmentName === '工程部' || departmentName === '总师办') {
      const userName = location.href.includes('sanqiao.hzsksc.com')
        ? '徐建平'
        : '王晨';
      const user = this.subSu.find((i) => i.name === userName);
      if (user) {
        this.no_12_UserId = user.id!.toString();
      }
    }
    if (departmentName === '党建纪检办公室') {
      const userName = location.href.includes('sanqiao.hzsksc.com')
        ? '陈文俊'
        : '吴桃';
      const user = this.subSu.find((i) => i.name === userName);
      if (user) {
        this.no_12_UserId = user.id!.toString();
      }
    }
    if (
      departmentName === '前期部' ||
      departmentName === '安全部' ||
      departmentName === '综合办' ||
      departmentName === '财务部'
    ) {
      const userName = location.href.includes('sanqiao.hzsksc.com')
        ? '张科峰'
        : '徐丹';
      const user = this.subSu.find((i) => i.name === userName);
      if (user) {
        this.no_12_UserId = user.id!.toString();
      }
    }
    this.onNo12UserChange();
  }

  onNo12UserChange() {
    if (
      `${this.no_13_UserId}` === `${this.no_12_UserId}` ||
      `${this.no_14_UserId}` === `${this.no_12_UserId}`
    ) {
      const restUser = this.subSu.filter(
        (user) => `${user.id}` !== `${this.no_12_UserId}`,
      );
      if (`${this.no_13_UserId}` === `${this.no_12_UserId}`) {
        if (restUser.length > 1) {
          this.no_13_UserId = restUser[0].id!.toString();
        } else {
          this.no_13_UserId = '';
          this.no_14_UserId = '';
        }
      }
      if (
        `${this.no_13_UserId}` === `${this.no_14_UserId}` ||
        `${this.no_12_UserId}` === `${this.no_14_UserId}`
      ) {
        if (restUser.length > 2) {
          this.no_14_UserId = restUser[1].id!.toString();
        } else {
          this.no_14_UserId = '';
        }
      }
    }
  }

  cancel() {
    this.data.onCancel();
  }

  confirm() {
    const no_4_UserInfo = new UserInfo();
    if (this.no_4_UserId) {
      const user = this.userList.find(
        (user) =>
          `${user.id}` === `${this.no_4_UserId}` &&
          `${user.departmentId}` === `${this.no_4_DepartmentId}`,
      );
      if (user) {
        no_4_UserInfo.organizationType = user.organizationType;
        no_4_UserInfo.organizationId = user.organizationId;
        no_4_UserInfo.organizationShortName = user.organizationShortName;
        no_4_UserInfo.organizationName =
          user.organizationShortName ?? user.organizationName;
        no_4_UserInfo.userName = user.name;
        no_4_UserInfo.departmentId = user.departmentId;
        no_4_UserInfo.departmentName = user.departmentName;
        no_4_UserInfo.postId = user.postId;
        no_4_UserInfo.userId = user.id;
        no_4_UserInfo.postName = user.postName;
        no_4_UserInfo.postPerformance = user.postPerformance;
        no_4_UserInfo.performance = user.performance;
        no_4_UserInfo.sealHolder = user.sealHolder;
      }
    }
    const no_12_UserInfo = new UserInfo();
    if (this.no_12_UserId) {
      const user = this.userList.find(
        (user) => `${user.id}` === `${this.no_12_UserId}`,
      );
      if (user) {
        no_12_UserInfo.organizationType = user.organizationType;
        no_12_UserInfo.organizationId = user.organizationId;
        no_12_UserInfo.organizationShortName = user.organizationShortName;
        no_12_UserInfo.organizationName =
          user.organizationShortName ?? user.organizationName;
        no_12_UserInfo.userName = user.name;
        no_12_UserInfo.departmentId = user.departmentId;
        no_12_UserInfo.departmentName = user.departmentName;
        no_12_UserInfo.postId = user.postId;
        no_12_UserInfo.userId = user.id;
        no_12_UserInfo.postName = user.postName;
        no_12_UserInfo.postPerformance = user.postPerformance;
        no_12_UserInfo.performance = user.performance;
        no_12_UserInfo.sealHolder = user.sealHolder;
      }
    }
    const no_13_UserInfo = new UserInfo();
    if (this.no_13_UserId) {
      const user = this.userList.find(
        (user) => `${user.id}` === `${this.no_13_UserId}`,
      );
      if (user) {
        no_13_UserInfo.organizationType = user.organizationType;
        no_13_UserInfo.organizationId = user.organizationId;
        no_13_UserInfo.organizationShortName = user.organizationShortName;
        no_13_UserInfo.organizationName =
          user.organizationShortName ?? user.organizationName;
        no_13_UserInfo.userName = user.name;
        no_13_UserInfo.departmentId = user.departmentId;
        no_13_UserInfo.departmentName = user.departmentName;
        no_13_UserInfo.postId = user.postId;
        no_13_UserInfo.userId = user.id;
        no_13_UserInfo.postName = user.postName;
        no_13_UserInfo.postPerformance = user.postPerformance;
        no_13_UserInfo.performance = user.performance;
        no_13_UserInfo.sealHolder = user.sealHolder;
      }
    }
    const no_14_UserInfo = new UserInfo();
    if (this.no_14_UserId) {
      const user = this.userList.find(
        (user) => `${user.id}` === `${this.no_14_UserId}`,
      );
      if (user) {
        no_14_UserInfo.organizationType = user.organizationType;
        no_14_UserInfo.organizationId = user.organizationId;
        no_14_UserInfo.organizationShortName = user.organizationShortName;
        no_14_UserInfo.organizationName =
          user.organizationShortName ?? user.organizationName;
        no_14_UserInfo.userName = user.name;
        no_14_UserInfo.departmentId = user.departmentId;
        no_14_UserInfo.departmentName = user.departmentName;
        no_14_UserInfo.postId = user.postId;
        no_14_UserInfo.userId = user.id;
        no_14_UserInfo.postName = user.postName;
        no_14_UserInfo.postPerformance = user.postPerformance;
        no_14_UserInfo.performance = user.performance;
        no_14_UserInfo.sealHolder = user.sealHolder;
      }
    }
    const suUserInfo = new UserInfo();
    if (this.suUserId) {
      const user = this.userList.find(
        (user) => `${user.id}` === `${this.suUserId}`,
      );
      if (user) {
        suUserInfo.organizationType = user.organizationType;
        suUserInfo.organizationId = user.organizationId;
        suUserInfo.organizationShortName = user.organizationShortName;
        suUserInfo.organizationName =
          user.organizationShortName ?? user.organizationName;
        suUserInfo.userName = user.name;
        suUserInfo.departmentId = user.departmentId;
        suUserInfo.departmentName = user.departmentName;
        suUserInfo.postId = user.postId;
        suUserInfo.userId = user.id;
        suUserInfo.postName = user.postName;
        suUserInfo.postPerformance = user.postPerformance;
        suUserInfo.performance = user.performance;
        suUserInfo.sealHolder = user.sealHolder;
      }
    }
    this.data.onConfirm!({
      no_4_User: no_4_UserInfo,
      no_12_User: no_12_UserInfo,
      no_13_User: no_13_UserInfo,
      no_14_User: no_14_UserInfo,
      suUser: suUserInfo,
    });
  }

  get canConfirm() {
    if (!this.no_4_UserId || !this.no_12_UserId) {
      return false;
    }
    return true;
  }
}
